const languages: any = {
    it: require('../../locales/it.json'),
    en: require('../../locales/en.default.json'),
    fr: require('../../locales/fr.json'),
};

export const getRequestedLanguages = (languageCode: string) => {
    if (languages[languageCode]) {
        return languages[languageCode].berardi;
    }
    return languages.it.berardi;
};
